import React from "react";
import "./AdvisoryHero.css";

const AdvisoryHero = () => {
  return (
    <section className="advisory-hero-section">
      <div className="container text-center">

        <h1 className="hero-title">
          The <span className="darkO-txt">People</span> Who’ve Already
          <br />
          Solved The <span className="darkO-txt">Hard Workforce Problems</span>
        </h1>

        <p className="hero-text advisory-hero-description">
          Our Workforce Development Advisory Council brings together senior
          leaders from enterprise, government, healthcare, and policy.
        </p>

      </div>
    </section>
  );
};

export default AdvisoryHero;